export { default } from './NoticeList';

